var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
import { SvgIcon } from '@mui/material';
function PrinterIconInner(props) {
    return (React.createElement("svg", __assign({ width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M18 8H20.9991C22.1042 8 23 8.89215 23 9.99503V18.005C23 19.1068 22.1035 20 20.9991 20H18V21.003C18 21.5536 17.5515 22 16.9975 22H7.00247C6.44882 22 6 21.5527 6 21.003V20H3.00091C1.89584 20 1 19.1079 1 18.005V9.99503C1 8.8932 1.89655 8 3.00091 8H6V2.99703C6 2.44639 6.45081 2 7.00043 2H16.9996C17.5521 2 18 2.44726 18 2.99703V8ZM6 16C5.44576 16 5 15.5561 5 15C5 14.4477 5.44995 14 5.99562 14H18.0044C18.5542 14 19 14.4439 19 15C19 15.5523 18.5501 16 18.0044 16L18 18H21V10H3V18H6V16ZM8 16V20H16V16H8ZM6 13C5.44772 13 5 12.5523 5 12C5 11.4477 5.44772 11 6 11C6.55228 11 7 11.4477 7 12C7 12.5523 6.55228 13 6 13ZM8 4V8H16V4H8Z", fill: "" })));
}
export var PrinterIcon = function (props) { return (React.createElement(SvgIcon, __assign({ inheritViewBox: true, component: PrinterIconInner }, props))); };
//# sourceMappingURL=PrinterIcon.js.map